import { useTPrefix } from 'app/components/management/title';
import { TopLoadingIndicator } from 'app/components/top-loading-indicator';
import { LoanFilterKey, useAllLoans } from 'app/network/loan';
import { useOnFocus } from 'app/services/on-focus';
import { LoanType } from 'app/types/loan';
import type { NavigationScreen } from 'app/types/navigation';
import { useRegisterLoading } from 'app/utils/performance/screen-perf-context';
import { usePageTitle } from 'app/utils/web-helpers';
import { useEffect } from 'react';
import { DesktopLoans } from './desktop-loans';
import { MobileLoans } from './mobile-loans';

export const MyLoansScreenComponent: React.ComponentType<
  React.ComponentProps<NavigationScreen<'my-loans'>> & { isDesktop: boolean }
> = ({ route, isDesktop }) => {
  const loanType = route.params?.type ?? LoanType.Borrowing;
  const tPrefix = useTPrefix();
  const setPageTitle = usePageTitle('loans');
  const useTabbedLayout = !isDesktop;

  useEffect(() => setPageTitle(`${tPrefix}${loanType}.title`), [loanType, setPageTitle, tPrefix]);

  const myLoansQuery = useAllLoans(LoanFilterKey.Management, loanType, { throwOnError: true });

  useOnFocus(() => {
    void myLoansQuery.refetch();
  });

  useRegisterLoading(myLoansQuery.isPending, 'MyLoansScreen');

  const contentProps = {
    isLoading: myLoansQuery.isLoading,
    isRefetching: myLoansQuery.isRefetching,
    loans: myLoansQuery.data ?? [],
    loanType,
    onRefresh: () => void myLoansQuery.refetch(),
    tPrefix,
  };

  return (
    <>
      <TopLoadingIndicator isLoading={myLoansQuery.isLoading} />
      {useTabbedLayout ? <MobileLoans {...contentProps} /> : <DesktopLoans {...contentProps} />}
    </>
  );
};
